import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { getFindBrandsFilterOptionsKey } from '../../../../../services/modules/filterOptions/filterOptions.keys';
import filterOptionsRepository from '../../../../../services/modules/filterOptions/repositories/filterOptions.repository';
import { DefaultFilters } from '../../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { useAppEnvironmentStore } from '../../../../../stores/AppEnvironment/appEnvironment.store';
import { selectIsInStoreEnvironment } from '../../../../../stores/AppEnvironment/appEnvironment.store.selectors';
import useMultiDynamicOptionsSelector from '../multiOptionsSelectorFilter/useMultiDynamicOptionsSelector/useMultiDynamicOptionsSelector';

interface UseBrandsFilterParams {
  filterKey: string;
  defaultFilters?: DefaultFilters | null;
  shouldIgnoreDefaultFilters: boolean;
  queryLimit: number;
}

const useBrandsFilter = ({
  filterKey,
  defaultFilters,
  shouldIgnoreDefaultFilters,
  queryLimit,
}: UseBrandsFilterParams) => {
  const { translate } = useTranslation();
  const isInStoreEnvironment = useAppEnvironmentStore(selectIsInStoreEnvironment);
  const repository = filterOptionsRepository();

  const { cleanFilter, getSearchParamKeys, ...brandsFilter } = useMultiDynamicOptionsSelector({
    queryFn: repository.findBrandsFilterOptions,
    queryKeyFn: getFindBrandsFilterOptionsKey,
    defaultValues: isInStoreEnvironment ? defaultFilters?.[filterKey] : undefined,
    shouldIgnoreDefaultFilters,
    paramKeyToSearchMore: 'commercialName',
    paramKeyToSearchSpecifics: 'ids',
    key: filterKey,
    formatLabel: (rawData) => rawData.commercialName,
    defaultQueryParam: { limit: queryLimit },
    order: { commercialName: 'ASC' },
  });

  const selectedCount = brandsFilter.selectedOptions.length;
  const label =
    selectedCount > 0
      ? `${translate(LangEnum.GLOBAL_BRANDS)}: ${selectedCount} ${translate(LangEnum.GLOBAL_SELECTED_PLURAL)}`
      : translate(LangEnum.GLOBAL_BRANDS);

  return {
    label,
    cleanFilter,
    getSearchParamKeys,
    brandsFilter,
  };
};

export default useBrandsFilter;
